import { Flex } from "~/components/Flex";
import { useParams } from "react-router-dom";
import { SecurityPipelineGithubPageTabHeading } from "../SecurityPipelineGithubPageTabHeading/SecurityPipelineGithubPageTabHeading";
import { Stack } from "@mui/system";
import { SecurityPipelineGithubWorkflowsTable } from "./SecurityPipelineGithubWorkflowsTable";
import { useSecurityPipelineGithubOverviewTab } from "./hooks/useSecurityPipelineGithubOverviewTab";
import { useScope } from "~/hooks/useScope";
import { LoadingFailedPage } from "~/components/loading";
import { SecurityPipelineOverviewEmptyState } from "./SecurityPipelineGithubOverviewEmptyState";
import { Button } from "@mui/material";
import { Link as RouterLink } from "react-router-dom";
import { SecurityPipelineGithubStats } from "./SecurityPipelineGithubStats";
import { SecurityPipelineGithubWorkflowsTableSkeleton } from "./SecurityPipelineGithubWorkflowsTableSkeleton";
import { SecurityPipelineGithubPageTabHeadingSkeleton } from "../SecurityPipelineGithubPageTabHeading/SecurityPipelineGithubPageTabHeadingSkeleton";

export const SecurityPipelineGithubPageTabOverview = () => {
  const { activeScope } = useScope();
  const { integrationId } = useParams();
  const {
    workflowsRows,
    isEmpty,
    isLoading,
    error,
    animationKey,
    showParticles,
    handleReplay,
    paginationProps,
    handleStatusClick,
    organizationName,
    handleSortClick,
    orderBy,
  } = useSecurityPipelineGithubOverviewTab({
    scopeMrn: activeScope?.mrn || "",
  });

  if (error) {
    return <LoadingFailedPage what="Security Pipeline Github" />;
  }

  return (
    <Flex flexDirection="column" gap={4}>
      <Stack direction="row" justifyContent="space-between" alignItems="center">
        {isLoading ? (
          <SecurityPipelineGithubPageTabHeadingSkeleton />
        ) : !isEmpty ? (
          <SecurityPipelineGithubPageTabHeading
            title="Security pipeline is enabled in this space"
            description={`Managed by the ${organizationName} org.`}
          />
        ) : (
          <SecurityPipelineGithubPageTabHeading
            title="Get started with automation"
            description={`Select findings, or create a schedule to automate fixes. Managed by the ${organizationName} org.`}
          />
        )}
        <Stack direction="row" gap={1} sx={{ flexShrink: 0 }}>
          <Button
            variant="outlined"
            color="primary"
            component={RouterLink}
            to={`/space/findings/all?${activeScope?.params}&type=VULNERABILITY&type=ADVISORY`}
          >
            Go to findings
          </Button>
          {integrationId && (
            <Button
              variant="contained"
              color="primary"
              component={RouterLink}
              to={`/space/integrations/security_pipeline_github/${integrationId}/automate?${activeScope?.params}`}
            >
              Create Schedule
            </Button>
          )}
        </Stack>
      </Stack>
      <SecurityPipelineGithubStats
        animationKey={animationKey}
        showParticles={showParticles}
        onReplay={handleReplay}
      />
      {isLoading ? (
        <SecurityPipelineGithubWorkflowsTableSkeleton />
      ) : isEmpty ? (
        <SecurityPipelineOverviewEmptyState />
      ) : (
        <SecurityPipelineGithubWorkflowsTable
          rows={workflowsRows}
          paginationProps={paginationProps}
          onSort={handleSortClick}
          orderBy={orderBy}
          onStatusClick={handleStatusClick}
        />
      )}
    </Flex>
  );
};
